export const features = {
  standard: [
    "Route Map Tracking",
    "Geofence Attendance",
    "Timesheet Report & Approval",
    "Team & Shift Management",
    "Payroll Management",
    "Members & Teams",
    "Integrations",
  ],
  elite: [
    "Customers Management",
    "Projects & Jobs",
    "Job Approval Process",
    "Job Scheduling",
    "Photo & Audio Evidence Upload",
    "+ More Features",
  ],
};
